import * as yup from "yup";

const structureValidation = (messages) => {
  const amount = yup
    .number()
    .typeError(messages.REQUIRED)
    .min(0, messages.INVALID_VALUE)
    .required(messages.REQUIRED);

  return yup.object().shape({
    name: yup.string().typeError(messages.REQUIRED).required(messages.REQUIRED),
    dates: yup
      .array()
      .typeError(messages.REQUIRED)
      .of(yup.date().typeError(messages.REQUIRED))
      .length(2, messages.REQUIRED)
      .required(messages.REQUIRED),
    insurancePlan: yup.object().shape({
      id: yup.string().typeError(messages.REQUIRED).required(messages.REQUIRED),
    }),
    amounts: yup.object().shape({
      single: amount,
      duo: amount,
      family: amount,
    }),
  });
};

export default structureValidation;
